// extracted by mini-css-extract-plugin
export default {"InputCurrency":"InputCurrency_InputCurrency__jUGdL","InputCurrency_active":"InputCurrency_InputCurrency_active__edZfp"};